/* ============
 * Fetch the postal suggestions.
 * ============
 *
 * Found postal suggestions.
 */

import Vue from 'vue';
import postalTransformer from './../../transformers/postal';
import store from './../../store';

const success = ({ data }, resolve) => {
  const postals = postalTransformer.fetchCollection(data.data);

  store.dispatch('fetchPostals', { postals });
  resolve(postals);
};

const failed = () => {
};

export default postCode => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`postal/suggestions/${postCode}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/postal/fetchSuggestions.js